import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBirthChartsDataContext } from './hooks/useBirthChartsDataContext';

export const OccurrenceLocation = () => {
    const { chartData } = useBirthChartsDataContext();


    return (
        <SimpleBars
            title={'Local de Ocorrência'}
            horizontal={false}
            subtitles={chartData?.occurrenceLocation?.map((item) => item.description)}
            values={chartData?.occurrenceLocation?.map((item) => item.total  ||  0)}
        />
    );
};
